import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../misc/Dashboard.css';

function ParentMeetingInvitesCard() {
  const token = sessionStorage.getItem('jwtToken');
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const formatDateTime = (value) => {
    if (!value) return '-';

    try {
      return new Intl.DateTimeFormat('nl-NL', {
        dateStyle: 'medium',
        timeStyle: 'short'
      }).format(new Date(value));
    } catch {
      return value;
    }
  };

  useEffect(() => {
    const fetchMeetingInvites = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/meeting-round/my-parent-invites`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = res.data?.data || [];
        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Error fetching parent meeting invites', err);
        setItems([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMeetingInvites();
  }, [token]);

const now = new Date();

const visibleItems = (items || []).filter((item) => {
  if (item.booking_start_at) {
    return new Date(item.booking_start_at) >= now;
  }

  return item.booking_close_at && new Date(item.booking_close_at) >= now;
});

const summary = visibleItems.reduce(
  (acc, item) => {
    if (item.booking_start_at) {
      acc.booked += 1;
    } else if (item.booking_open_at && new Date(item.booking_open_at) > now) {
      acc.upcoming += 1;
    } else {
      acc.open += 1;
    }

    return acc;
  },
  { booked: 0, open: 0, upcoming: 0 }
);

  if (isLoading) {
    return null;
  }

  if (!visibleItems.length) {
    return null;
  }

  return (
    <div className="parent-meeting-card parent-meeting-card--highlight">
      <div className="parent-meeting-card__top">
        <div className="parent-meeting-card__badge">Oudergesprekken</div>
        <div className="parent-meeting-card__icon">🗓️</div>
      </div>

      <div className="parent-meeting-card__content">
        <h3>Oudergesprekken</h3>
        <p>
          {summary.open > 0 && `${summary.open} open`}
          {summary.open > 0 && summary.booked > 0 ? ' • ' : ''}
          {summary.booked > 0 && `${summary.booked} ingepland`}
          {(summary.open > 0 || summary.booked > 0) && summary.upcoming > 0 ? ' • ' : ''}
          {summary.upcoming > 0 && `${summary.upcoming} binnenkort open`}
        </p>
      </div>

      <div className="parent-meeting-card__list">
        {visibleItems.map((item) => {
          const isBooked = Boolean(item.booking_start_at);
          const beforeOpen =
            !isBooked &&
            item.booking_open_at &&
            new Date(item.booking_open_at) > now;

          return (
            <div
              key={item.invite_id}
              className="parent-meeting-card__list-item"
            >
              <div className="parent-meeting-card__list-main">
                <div className="parent-meeting-card__list-title">
                  {item.round_title || 'Oudergesprek'}
                </div>
                <div className="parent-meeting-card__list-subtitle">
                  {item.student_name || '-'}
                </div>

                {isBooked ? (
                  <div className="parent-meeting-card__list-meta">
                    Ingepland op {formatDateTime(item.booking_start_at)}
                  </div>
                ) : beforeOpen ? (
                  <div className="parent-meeting-card__list-meta">
                    Inschrijven vanaf {formatDateTime(item.booking_open_at)}
                  </div>
                ) : (
                  <div className="parent-meeting-card__list-meta">
                    Beschikbaar om in te plannen
                  </div>
                )}
              </div>

              <div className="parent-meeting-card__list-action">
                {isBooked ? (
                  <Link
                    to={`/oudergesprekken/inschrijven/${item.invite_id}`}
                    className="btn btn-outline-secondary btn-sm"
                  >
                    Bekijken
                  </Link>
                ) : beforeOpen ? (
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    disabled
                  >
                    Nog niet open
                  </button>
                ) : (
                  <Link
                    to={`/oudergesprekken/inschrijven/${item.invite_id}`}
                    className="btn btn-outline-primary btn-sm"
                  >
                    Inschrijven
                  </Link>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ParentMeetingInvitesCard;